@if (editMode) {
  <span [formGroup]="formGroup" class="align-center">
    <mat-checkbox formControlName="{{ fieldConfig.name }}"></mat-checkbox>
  </span>
}

@if (!editMode) {
  <span class="checkbox-item">
    <mat-checkbox [checked]="data" [disabled]="true"></mat-checkbox>
  </span>
}
